import { createContext } from 'react';
import {
    QUERY_KEYS_SECURITY,
    useChartsData
} from '../../../../Common/hooks/useChartsData';
import { useSecurityFiltersContext } from '../../../Common/Filters/hooks/useSecurityFiltersContext';

export const DeathCauseChartsDataContext = createContext();

const DeathCauseChartsDataProvider = ({ children }) => {
    const { filters } = useSecurityFiltersContext();
    const currentYear = new Date().getFullYear();
    const filterParams = {
            year: filters.year?.value || currentYear,
            month: filters.month?.value,
            location: filters.unidade.value,
            city: filters.cidade?.value,
    }

    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_SECURITY.IML_DEATHCAUSES,
            url: 'governanceroom/securitydashboard/iml/causaMortis'
        },
        filterParams
    );

    const chartData = {
              deathCauseAnual: data?.anualEvolution || [],
              deathCauseMonth: data?.monthEvolution || []
          }

    return (
        <DeathCauseChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </DeathCauseChartsDataContext.Provider>
    );
};

export default DeathCauseChartsDataProvider;
